import { memo } from 'react';

function BankIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.88889 11.5556V13.8889M10 11.5556V13.8889M13.1111 11.5556V13.8889M3 17H17M3 8.44444H17M3 6.11111L10 3L17 6.11111M3.77778 8.44444H16.2222V17H3.77778V8.44444Z"
        stroke="#6B7280"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(BankIcon);
